import { aggregateKitchenItems, normalizeAcceptedKitchenJob } from "./itemWorkload";
import { filterSortKitchenOrders } from "./orderPresentation";
import { isLiveTask } from "./kitchenActions";

const outstanding = (item) => isLiveTask(item) && item.status !== "READY" && item.taskStatus !== "READY";
const confirmed = (ready, jobId, taskId) => (ready[jobId] || []).includes(taskId);
const completed = (item) =>
  !["REMOVED", "CANCELLED", "CANCELED", "REJECTED"].includes(item?.status) &&
  !["REMOVED", "CANCELLED", "CANCELED", "REJECTED"].includes(item?.taskStatus) &&
  (["COMPLETED", "READY"].includes(item?.status) || ["COMPLETED", "READY"].includes(item?.taskStatus));
const inStation = (item, stations) => !stations.length || stations.includes(item.metadata?.prepStationId);

/** Preserve completed rows only while the current ticket still has outstanding work. */
export const getRushProcessingOrders = (orders = [], ready = {}, stations = [], retained = {}) => {
  const tickets = orders.filter((order) =>
    ["IN_PROGRESS", "ACCEPTED"].includes(order.status)
  );
  return filterSortKitchenOrders(tickets.map((order) => {
    const current = order.items || [];
    const missingCompleted = (retained[order.id]?.items || []).filter((item) =>
      !current.some((candidate) => candidate.taskId === item.taskId));
    const items = [...current, ...missingCompleted].filter((item) =>
      (outstanding(item) || completed(item)) && inStation(item, stations));
    return { ...order, items };
  }).filter((order) => order.items.some((item) =>
    outstanding(item) && !confirmed(ready, order.id, item.taskId)
  )), { sort: "oldest" });
};

/** Outstanding preparation includes both new and already-accepted work. */
export const getRushPreparationGroups = (jobs = [], ready = {}, stations = []) => {
  const remainingJobs = jobs.map((job) => normalizeAcceptedKitchenJob({
    ...job,
    status: job.status === "ACCEPTED" ? "IN_PROGRESS" : job.status,
    tasks: (job.tasks || []).filter((task) => outstanding(task) &&
      !confirmed(ready, job.jobId, task.taskId)),
  }));
  return aggregateKitchenItems(remainingJobs, stations).map((group) => ({
    key: group.key, name: group.name, quantity: group.totalQty,
    pendingQty: group.pendingQty, processingQty: group.processingQty,
    orderIds: [...new Set(group.entries.map((entry) => entry.orderId))],
  })).filter((group) => group.quantity > 0);
};
